import { Trash, Plus } from "@fastly/consistently-icons"
import styled, { css } from "styled-components"

const IconButton = styled.button`
  padding: var(--size-space-2xs);
  border-radius: var(--size-radius-sm);
  background: transparent;
  border: 2px solid transparent;

  &:hover {
    background: rgba(255, 0, 0, 0.1);
  }

  svg {
    width: 18px;
    display: block;
  }
`

export const RemoveButton = (props) => (
  <IconButton type="button" {...props}>
    <Trash color="var(--red)" />
  </IconButton>
)

export const Button = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--size-space-xs);
    padding: var(--size-space-md);
    border-radius: var(--size-radius-md);
    font: var(--text-md);
    font-weight: 600;
    background-color: var(--color-link);
    color: var(--white);
    border: 0;
    white-space: nowrap;

    &:hover {
      background-color: var(--blue);
    }

    &:disabled {
      background-color: var(--grey-40);
      color: var(--grey-70);
    }

    @media (min-width: ${theme.breakpoints.md}) {
      padding: var(--size-space-xs) var(--size-space-md);
    }
  `
)

const ButtonText = styled.span`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: inline;
  }
`

export const AddButton = ({ children, ...props }) => (
  <Button {...props}>
    <Plus width="1.125rem" height="1.125rem" color="currentColor" />
    <ButtonText>{children}</ButtonText>
  </Button>
)
